import { render, staticRenderFns } from "./ResponderTable.vue?vue&type=template&id=0227648a&scoped=true&"
import script from "./ResponderTable.vue?vue&type=script&lang=js&"
export * from "./ResponderTable.vue?vue&type=script&lang=js&"
import style0 from "./ResponderTable.vue?vue&type=style&index=0&id=0227648a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0227648a",
  null
  
)

export default component.exports